(function () {
  'use strict';

  var READERS_TYPE = 'reading';
  var MOBILE_QUERY = '(max-width: 767px)';
  var VERIFY_ID = 'la-verify-prescription';

  /*
    Turns whichever field is holding the customer up into the button's label.
    Matched on loose patterns rather than exact names so a rename on Lens
    Advizor's side degrades to the generic wording instead of breaking.
  */
  var BLOCKERS = [
    [/diopter/i, 'Choose your strength'],
    [/prescription-file/i, 'Upload your prescription'],
    [/verify-prescription/i, 'Confirm your prescription'],
    [/pd-value/i, 'Choose your PD'],
    [/sph|cyl|axis|\badd\b|prism/i, 'Complete your prescription values']
  ];

  function blockerLabel(field, fallback) {
    var key = field.name || field.id || '';

    for (var i = 0; i < BLOCKERS.length; i++) {
      if (BLOCKERS[i][0].test(key)) return BLOCKERS[i][1];
    }

    return fallback;
  }

  // Lens Advizor hides some inputs behind styled controls, and a hidden node has
  // no layout position to scroll to. Walk up to something actually on screen.
  function visibleAnchor(node) {
    while (node && !node.offsetParent && node.parentElement) node = node.parentElement;
    return node;
  }

  function replay(node, className) {
    if (!node) return;
    node.classList.remove(className);
    void node.offsetWidth;
    node.classList.add(className);
  }

  function money(value) {
    var formatted;

    if (window.theme && window.theme.moneyFormat && window.Shopify && window.Shopify.formatMoney) {
      formatted = window.Shopify.formatMoney(Math.round(value * 100), window.theme.moneyFormat);
    } else {
      formatted = '$' + Number(value).toFixed(2);
    }

    return formatted.replace(/\.00(?!\d)/, '');
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  // A preview of what is still to come. Decorative only, so it is kept out of
  // the accessibility tree — these steps do not exist yet.
  function ghostHead(index, title) {
    var head = element('div', 'lens-flow__step-head lens-flow__step-head--ghost');

    head.setAttribute('aria-hidden', 'true');
    head.appendChild(element('span', 'lens-flow__step-number', 'Step ' + index));
    head.appendChild(element('span', 'lens-flow__step-title', title));

    return head;
  }

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Steps animate in on translateY, so the offset chain is read instead of
  // getBoundingClientRect to get the settled position rather than a mid-frame one.
  function documentTop(node) {
    var top = 0;

    while (node) {
      top += node.offsetTop;
      node = node.offsetParent;
    }

    return top;
  }

  function isPinned(node) {
    var position = window.getComputedStyle(node).position;
    return position === 'fixed' || position === 'sticky';
  }

  // The stuck header wrapper is a zero-height fixed box with the bar positioned
  // absolutely inside it, so the bar itself has to be measured. The setting is
  // read rather than the current stuck state because the header pins itself
  // partway through the scroll this offset is being calculated for.
  function stickyOffset() {
    var gap = 20;
    var bar = document.querySelector('[data-header-height]');
    if (!bar) return gap;

    var wrapper = bar.closest('[data-header-wrapper]');
    var mode = wrapper && wrapper.getAttribute('data-header-sticky');
    var pinned = mode === 'sticky' || mode === 'directional';

    if (!pinned) pinned = isPinned(bar) || !!(wrapper && isPinned(wrapper));
    if (!pinned) return gap;

    return bar.getBoundingClientRect().height + gap;
  }

  function readOnFile(container) {
    var script = container.querySelector('[data-lens-flow-rx]');
    if (!script) return null;

    try {
      var rx = JSON.parse(script.textContent);
      return rx && rx.type ? rx : null;
    } catch (error) {
      return null;
    }
  }

  function rxSummary(rx) {
    if (rx.diopters && !rx.od) return 'Strength ' + rx.diopters.split(' | ')[0];

    var eye = function (raw) {
      return String(raw || '')
        .replace(/ \| /g, ' / ')
        .replace(/x0*(\d+)/, '$1°');
    };
    var parts = ['Right ' + eye(rx.od), 'Left ' + eye(rx.os)];
    var pd = String(rx.pd || '');

    if (/^Single PD/.test(pd)) {
      parts.push('PD ' + pd.split(' | ')[1].replace('.00', ''));
    } else if (/^OD - /.test(pd)) {
      var dual = pd.split(' | ');
      parts.push('PD ' + dual[0].replace('OD - ', '').replace('.00', '') + ' / ' + (dual[1] || '').replace('OS - ', '').replace('.00', ''));
    }

    return parts;
  }

  function LensFlow(container) {
    this.onFile = readOnFile(container);
    this.rxApplied = false;
    this.rxFilling = false;
    this.rxError = '';
    this.rxPhoto = '';
    this.container = container;
    this.productId = container.getAttribute('data-lens-flow-product');
    this.seedFlowId = container.getAttribute('data-lens-flow-id') || '';
    this.bootSlow = false;
    this.bootTimer = null;
    this.soldOut = false;
    this.addedToCart = false;
    this.scope = container.closest('.product-single') || container.parentElement;
    this.form = this.scope && this.scope.querySelector('form[action*="/cart/add"]');
    this.config = null;
    this.branch = '';
    this.selection = { type: null, item: null, variant: null };
    this.panelMounted = false;
    this.opening = false;
    this.requestId = 0;
    this.failed = false;
    this.bootFailed = false;
    this.seenSteps = {};
    this.host = null;
    this.sticky = null;
    this.stickyPrice = null;
    this.productJson = null;
    this.pendingScroll = null;
    this.ready = false;
    this.userScrolled = false;
    this.wasPanelMounted = false;
    this.formTouched = false;
  }

  LensFlow.prototype.scrollToStep = function (key, gentle) {
    var target =
      key === 'first'
        ? this.container.querySelector('[data-lens-step]')
        : this.container.querySelector('[data-lens-step="' + key + '"]');

    if (!target) return;

    var offset = stickyOffset();
    var current = window.pageYOffset || document.documentElement.scrollTop || 0;
    var docTop = documentTop(target);

    // Entering a branch should not yank the page when the flow already sits in
    // the comfortable reading band; advancing a step always re-anchors.
    if (gentle) {
      var viewportTop = docTop - current;
      if (viewportTop >= offset && viewportTop <= window.innerHeight * 0.55) return;
    }

    var top = Math.max(0, docTop - offset);
    if (Math.abs(top - current) < 24) return;

    try {
      window.scrollTo({ top: top, behavior: reduceMotion() ? 'auto' : 'smooth' });
    } catch (error) {
      window.scrollTo(0, top);
    }
  };

  LensFlow.prototype.flushScroll = function () {
    var pending = this.pendingScroll;
    if (!pending) return;

    this.pendingScroll = null;
    this.userScrolled = false;

    var self = this;
    var run = function () {
      self.scrollToStep(pending.key, pending.gentle);
    };

    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 16);
  };

  LensFlow.prototype.variantId = function () {
    var input = this.form && this.form.querySelector('[name="id"]');
    return input ? input.value : null;
  };

  LensFlow.prototype.framePrice = function () {
    if (!this.productJson) {
      var script = this.scope && this.scope.querySelector('[data-product-json]');
      if (!script) return 0;
      try {
        this.productJson = JSON.parse(script.textContent);
      } catch (error) {
        return 0;
      }
    }

    var id = this.variantId();
    var variants = this.productJson.variants || [];

    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i].price / 100;
    }

    return (this.productJson.price || 0) / 100;
  };

  // The coating variant is what Lens Advizor adds to the cart, so its price is
  // the whole lens price, not an increment on the item price.
  LensFlow.prototype.lensPrice = function () {
    var variant = this.selection.variant;
    var item = this.selection.item;

    if (variant && variant.price !== undefined && variant.price !== null) {
      return Number(variant.price) || 0;
    }
    if (item && item.price !== undefined && item.price !== null) {
      return Number(item.price) || 0;
    }
    return 0;
  };

  LensFlow.prototype.ensureSticky = function () {
    if (this.sticky) return this.sticky;

    var wrap = element('div', 'lens-flow-sticky');
    wrap.hidden = true;

    var real = this.scope && this.scope.querySelector('[data-add-to-cart]');
    var label = 'Add to Cart';

    // Lens Advizor hides the real button at runtime (la-visiblity-hidden class
    // plus inline display:none), so only the theme classes and the custom
    // properties are safe to copy — never its live class list or style.
    var button = element('button', 'lens-flow-sticky__btn uppercase btn--full btn--add-to-cart');
    button.type = 'button';

    if (real) {
      for (var i = 0; i < real.style.length; i++) {
        var prop = real.style[i];
        if (prop.indexOf('--') === 0) {
          button.style.setProperty(prop, real.style.getPropertyValue(prop));
        }
      }

      var text = real.querySelector('[data-add-to-cart-text]');
      if (text && text.textContent.trim()) label = text.textContent.trim();
    }

    var state = element('span', 'btn-state-ready');

    this.stickyLabel = element('span', '', label);
    this.cartLabel = label;
    state.appendChild(this.stickyLabel);

    var dot = element('span', 'lens-flow-sticky__dot', '•');
    dot.setAttribute('aria-hidden', 'true');
    state.appendChild(dot);
    this.stickyDot = dot;

    this.stickyPrice = element('span', 'lens-flow-sticky__price', '');
    state.appendChild(this.stickyPrice);
    button.appendChild(state);
    this.stickyButton = button;

    var self = this;
    button.addEventListener('click', function () {
      self.stickySubmit();
    });

    wrap.appendChild(button);

    if (this.container.parentNode) {
      this.container.parentNode.insertBefore(wrap, this.container.nextSibling);
    } else {
      document.body.appendChild(wrap);
    }

    this.sticky = wrap;
    return wrap;
  };

  /*
    What still stands between the customer and the cart, as a label plus the
    field to send them to. Null once nothing is outstanding. Lens Advizor leaves
    its own button permanently enabled and leans on native constraint
    validation, so the form's own validity is the source of truth.
  */
  LensFlow.prototype.blocker = function () {
    if (!this.isComplete()) return { label: 'Choose your coating', field: null };

    // Readers finish on a reading strength, not a prescription.
    var readers = this.branch === 'readers';
    var stepLabel = readers ? 'Choose your strength' : 'Enter your prescription';

    var form = document.getElementById('la-prescription-form');
    if (!form || !form.elements) return { label: stepLabel, field: null };

    /*
      Until they have actually started, the step itself is the instruction. The
      sphere selects arrive pre-filled at 0.00, so the first invalid field is the
      PD picker in the middle of the form — naming that to someone who has not
      typed anything yet is precise and useless.
    */
    if (!this.formTouched) return { label: stepLabel, field: null };

    for (var i = 0; i < form.elements.length; i++) {
      var field = form.elements[i];
      if (field.disabled || !field.willValidate) continue;
      if (field.validity && !field.validity.valid) {
        return {
          label: blockerLabel(field, readers ? stepLabel : 'Complete your prescription'),
          field: field
        };
      }
    }

    return null;
  };

  LensFlow.prototype.revealBlocker = function (field) {
    // The verification checkbox is mirrored into the bar on phones, so the copy
    // they can actually reach is inches away — flag it instead of scrolling off
    // to the hidden original.
    if (field && field.id === VERIFY_ID && this.verifyRow && !this.verifyRow.hidden) {
      replay(this.verifyRow, 'is-flagged');
      return;
    }

    var anchor = field && visibleAnchor(field);

    if (!anchor) {
      this.scrollToStep('panel');
      return;
    }

    var top = Math.max(0, documentTop(anchor) - stickyOffset());

    try {
      window.scrollTo({ top: top, behavior: reduceMotion() ? 'auto' : 'smooth' });
    } catch (error) {
      window.scrollTo(0, top);
    }

    if (anchor !== field) return;

    // Focus once the scroll has settled, or the browser fights it mid-flight.
    window.setTimeout(
      function () {
        try {
          field.focus({ preventScroll: true });
        } catch (error) {
          field.focus();
        }
      },
      reduceMotion() ? 0 : 420
    );
  };

  LensFlow.prototype.celebrate = function () {
    replay(this.stickyButton, 'is-ready-pulse');

    if (!reduceMotion() && navigator.vibrate) {
      try {
        navigator.vibrate(12);
      } catch (error) {
        /* vibration is a nicety; a refusal is not worth surfacing */
      }
    }
  };

  LensFlow.prototype.stickySubmit = function () {
    // Not ready yet: send them to whatever is missing rather than dead-ending.
    if (this.pending) {
      this.revealBlocker(this.pending.field);
      return;
    }

    var submit = null;

    if (this.panelMounted && this.host) {
      submit =
        this.host.querySelector('.la-prescription-form-btn') ||
        this.host.querySelector('.la-prescription-modal-footer button');
    }

    if (!submit) {
      // Surface Lens Advizor's own footer again if its button ever changes
      // class names, so the flow always has a working submit.
      if (this.panelMounted) {
        document.documentElement.classList.remove('lens-flow-sticky-active');
      }
      this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    submit.click();

    var host = this.host;
    window.setTimeout(function () {
      var error = host && host.querySelector('.la-error');
      if (error && error.offsetParent) {
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 700);
  };

  // The panel's checkbox is mirrored rather than moved: Lens Advizor rebuilds
  // that markup on every open, and a relocated node would orphan or duplicate.
  LensFlow.prototype.syncVerify = function () {
    var real = document.getElementById(VERIFY_ID);
    var show = !!real && this.panelMounted && window.matchMedia(MOBILE_QUERY).matches;

    if (!show) {
      if (this.verifyRow) this.verifyRow.hidden = true;
      return;
    }

    if (!this.verifyRow) {
      var self = this;
      var row = element('label', 'lens-flow-sticky__verify');
      var box = document.createElement('input');

      box.type = 'checkbox';
      row.appendChild(box);

      this.verifyText = element('span', '', '');
      row.appendChild(this.verifyText);
      this.verifyBox = box;
      this.verifyRow = row;
      this.sticky.insertBefore(row, this.sticky.firstChild);

      box.addEventListener('change', function () {
        var target = document.getElementById(VERIFY_ID);
        if (!target) return;
        target.checked = box.checked;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        self.updateSticky();
      });
    }

    var label = document.querySelector('label[for="' + VERIFY_ID + '"]');
    var copy = label
      ? label.textContent.trim()
      : 'I verify that my prescription has been entered correctly.';

    if (this.verifyText.textContent !== copy) this.verifyText.textContent = copy;
    if (this.verifyBox.checked !== real.checked) this.verifyBox.checked = real.checked;
    this.verifyRow.hidden = false;
  };

  /*
    While the customer is still picking options, the steps are short enough that
    the next section shows underneath. Pad the flow so the step being scrolled to
    can reach the top of the screen with nothing but the flow below it. The
    prescription form is tall enough to do this on its own, so the padding is
    dropped once it arrives.
  */
  LensFlow.prototype.updateTail = function () {
    this.container.style.paddingBottom = '';
    if (this.sticky) this.sticky.style.marginBottom = '';

    var steps = this.container.querySelectorAll('[data-lens-step]');
    var last = steps[steps.length - 1];

    // The spacer guards the intermediate steps only. Once the prescription
    // form has mounted the customer is on the last step, and any space left
    // here would separate the CTA bar from the end of the form.
    if (!last || this.panelMounted) return;

    var tail = this.container.getBoundingClientRect().bottom - last.getBoundingClientRect().top;
    var pad = Math.round(window.innerHeight - stickyOffset() - tail);
    if (pad <= 0) return;

    // The CTA bar follows the container in the flow on desktop, so the spacer
    // has to sit below the bar — inside the container it would wedge itself
    // between the form and the bar. On mobile the bar is fixed to the
    // viewport and out of the flow, so the container carries the spacer.
    var bar =
      this.sticky && !this.sticky.hidden && !window.matchMedia(MOBILE_QUERY).matches
        ? this.sticky
        : null;

    if (bar) bar.style.marginBottom = pad + 'px';
    else this.container.style.paddingBottom = pad + 'px';
  };

  LensFlow.prototype.updateSticky = function () {
    var active =
      !this.bootFailed &&
      !this.soldOut &&
      (this.branch === 'rx' || this.branch === 'readers') &&
      !!this.selection.item;

    if (!active && !this.sticky) return;

    var bar = this.ensureSticky();
    bar.hidden = !active;
    document.documentElement.classList.toggle('lens-flow-sticky-active', active);

    if (!active) {
      this.pending = null;
      return;
    }

    this.syncVerify();

    var pending = this.blocker();
    var wasPending = this.pending;
    this.pending = pending;

    // Muted but still tappable: a dead button gives no way to find what is
    // missing, so it keeps working and points at the gap instead.
    this.stickyButton.classList.toggle('is-waiting', !!pending);
    this.stickyLabel.textContent = pending ? pending.label : this.cartLabel;
    this.stickyDot.hidden = !!pending;
    this.stickyPrice.hidden = !!pending;

    if (!pending) {
      this.stickyPrice.textContent = money(this.framePrice() + this.lensPrice());
      if (wasPending) this.celebrate();
    }
  };

  LensFlow.prototype.typesForBranch = function () {
    if (!this.config) return [];

    return this.config.types.filter(function (type) {
      return this.branch === 'readers' ? type.name === READERS_TYPE : type.name !== READERS_TYPE;
    }, this);
  };

  LensFlow.prototype.start = function () {
    var bridge = window.LensFlowBridge;
    if (!bridge) return;

    var self = this;

    // Warm Lens Advizor's widget in the background either way; the
    // prescription step drives their UI, and booting it now means it is
    // usually ready by the time a customer has picked their lenses.
    var engineReady = bridge.whenAvailable(this.productId, this.variantId());
    engineReady.catch(function () {});

    this.bootTimer = window.setTimeout(function () {
      if (self.config || self.bootFailed) return;
      self.bootSlow = true;
      self.render();
    }, 7000);

    var loaded = this.seedFlowId
      ? bridge
          .whenShopReady()
          .then(function () {
            return bridge.loadConfig(self.productId, self.variantId(), self.seedFlowId);
          })
          .catch(function () {
            return engineReady.then(function () {
              return bridge.loadConfig(self.productId, self.variantId());
            });
          })
      : engineReady.then(function () {
          return bridge.loadConfig(self.productId, self.variantId());
        });

    loaded
      .then(function (config) {
        window.clearTimeout(self.bootTimer);
        self.config = config;
        self.applyRequestedType();
        self.container.classList.add('lens-flow--ready');
        document.documentElement.classList.add('lens-flow-active');
        self.render();
      })
      .catch(function () {
        window.clearTimeout(self.bootTimer);
        self.container.classList.remove('lens-flow--ready');
        document.documentElement.classList.remove('lens-flow-active');
        document.documentElement.classList.add('lens-flow-fallback');
        self.bootFailed = true;
        self.render();
      });
  };

  LensFlow.prototype.dismissPanel = function () {
    this.requestId += 1;
    this.formTouched = false;
    this.rxApplied = false;
    this.rxFilling = false;
    this.rxError = '';
    this.rxPhoto = '';

    if (!this.panelMounted && !this.opening) return;

    this.panelMounted = false;
    this.opening = false;
    this.closing = window.LensFlowBridge.closePanel();
  };

  LensFlow.prototype.resetAfterAdd = function () {
    this.pendingScroll = null;
    this.selection = { type: null, item: null, variant: null };
    this.seenSteps = {};
    this.failed = false;
    this.opening = false;
    this.wasPanelMounted = false;
    this.render();
    this.updateSticky();
  };

  LensFlow.prototype.setSoldOut = function (soldOut) {
    if (soldOut === this.soldOut) return;

    this.soldOut = soldOut;
    if (soldOut) this.dismissPanel();
    this.render();
  };

  LensFlow.prototype.setBranch = function (branch) {
    if (branch === this.branch) return;

    this.dismissPanel();
    this.branch = branch;
    this.seenSteps = {};
    this.selection = { type: null, item: null, variant: null };

    if (branch === 'readers') {
      var readers = this.typesForBranch()[0];
      if (readers) this.selection.type = readers;
    }

    // Entering a branch does not scroll; the sequence takes over from step two,
    // once there is a new step to move on to.
    this.render();
  };

  LensFlow.prototype.select = function (level, value) {
    if (
      level === 'variant' &&
      this.selection.variant &&
      String(this.selection.variant.id) === String(value.id) &&
      (this.panelMounted || this.opening)
    ) {
      return;
    }

    this.dismissPanel();

    if (level === 'type') {
      this.selection = { type: value, item: null, variant: null };
      this.pendingScroll = { key: 'item', gentle: false };
    } else if (level === 'item') {
      this.selection.item = value;
      this.selection.variant = value.variants.length === 1 ? value.variants[0] : null;
      this.pendingScroll = {
        key: value.variants.length > 1 ? 'variant' : 'panel',
        gentle: false
      };
    } else {
      this.selection.variant = value;
      this.pendingScroll = { key: 'panel', gentle: false };
    }

    this.render();

    if (this.isComplete()) this.openPanel();
  };

  LensFlow.prototype.openPanel = function () {
    if (this.opening || this.panelMounted || !this.isComplete()) return;

    var self = this;
    var token = ++this.requestId;

    this.failed = false;
    this.opening = true;
    this.render();

    var selection = {
      typeTitle: this.selection.type.title,
      itemId: this.selection.item.id,
      variantId: this.selection.variant.id,
      variantTitle: this.selection.variant.title,
      variantCount: (this.selection.item.variants || []).length
    };

    (this.closing || Promise.resolve())
      .then(function () {
        if (token !== self.requestId) return null;
        return window.LensFlowBridge.openAtPrescriptionStep(selection, self.host);
      })
      .then(function () {
        if (token !== self.requestId) return;
        self.opening = false;
        self.panelMounted = true;
        document.documentElement.classList.remove('lens-flow-fallback');
        self.render();
      })
      .catch(function () {
        if (token !== self.requestId) return;
        self.opening = false;
        self.failed = true;
        document.documentElement.classList.add('lens-flow-fallback');
        self.bootFailed = true;
        self.render();
      });
  };

  LensFlow.prototype.applyOnFile = function () {
    if (!this.panelMounted || this.rxFilling || !this.onFile) return;

    var self = this;
    var token = this.requestId;

    this.rxFilling = true;
    this.rxError = '';
    this.render();

    window.LensFlowBridge.fillPrescription(this.onFile)
      .then(
        function () {
          if (token !== self.requestId) return null;
          self.rxApplied = true;

          if (!self.onFile.photo || !document.querySelector('[name="la-prescription-file"]')) return null;

          self.rxPhoto = 'attaching';
          self.render();

          return window.LensFlowBridge.attachPhoto(self.onFile.photo).then(
            function () {
              if (token === self.requestId) self.rxPhoto = 'attached';
            },
            function () {
              if (token === self.requestId) self.rxPhoto = 'failed';
            }
          );
        },
        function () {
          if (token !== self.requestId) return;
          self.rxError =
            'We couldn’t fill in every value for this lens. Please check and complete your prescription below.';
        }
      )
      .then(function () {
        if (token !== self.requestId) return;
        self.rxFilling = false;
        self.formTouched = true;
        self.render();
      });
  };

  LensFlow.prototype.renderReuse = function () {
    var rx = this.onFile;
    if (!rx || !this.selection.type || rx.type !== this.selection.type.title) return null;

    var self = this;
    var unavailable = rx.expired || rx.prism;
    var box = element('div', 'lens-flow__reuse' + (unavailable ? ' is-unavailable' : ''));

    box.appendChild(element('p', 'lens-flow__reuse-title', 'Your prescription on file'));
    box.appendChild(element('p', 'lens-flow__reuse-meta', 'From order ' + rx.order + ', ' + rx.date));

    if (rx.expired) {
      box.appendChild(
        element(
          'p',
          'lens-flow__reuse-text',
          'It’s more than ' + rx.months + ' months old, so it can’t be reused. Please enter your current prescription below.'
        )
      );
      return box;
    }

    if (rx.prism) {
      box.appendChild(
        element(
          'p',
          'lens-flow__reuse-text',
          'It includes prism, which has to be entered by hand. Please enter your prescription below.'
        )
      );
      return box;
    }

    var summary = rxSummary(rx);
    var list = element('p', 'lens-flow__reuse-values');
    (Array.isArray(summary) ? summary : [summary]).forEach(function (line) {
      list.appendChild(element('span', '', line));
    });
    box.appendChild(list);

    if (this.rxApplied) {
      var readers = rx.diopters && !rx.od;
      box.classList.add('is-applied');
      var appliedText;

      if (readers) {
        appliedText = 'Filled in below. Check the strength before adding to cart.';
      } else if (this.rxPhoto === 'attaching') {
        appliedText = 'Filled in below. Adding the prescription photo from your last order…';
      } else if (this.rxPhoto === 'attached') {
        appliedText = 'Filled in below, including the prescription photo from your last order. Check every value, then confirm it.';
      } else {
        appliedText = 'Filled in below. Check every value, then upload a photo of your prescription and confirm it.';
      }

      box.appendChild(element('p', 'lens-flow__reuse-text', appliedText));
      return box;
    }

    if (this.rxError) {
      box.appendChild(element('p', 'lens-flow__reuse-text lens-flow__reuse-text--error', this.rxError));
    }

    box.appendChild(
      element(
        'p',
        'lens-flow__reuse-text',
        'Only use it if your prescription hasn’t changed since. Valid until ' + rx.expires + '.'
      )
    );

    var button = element(
      'button',
      'lens-flow__cta lens-flow__reuse-btn btn',
      this.rxFilling ? 'Filling in…' : 'Use this prescription'
    );
    button.type = 'button';
    button.disabled = !this.panelMounted || this.rxFilling;
    button.addEventListener('click', function () {
      self.applyOnFile();
    });
    box.appendChild(button);

    return box;
  };

  LensFlow.prototype.isComplete = function () {
    return !!(this.selection.type && this.selection.item && this.selection.variant);
  };

  LensFlow.prototype.markSeen = function (key) {
    if (this.seenSteps[key]) return '';
    this.seenSteps[key] = true;
    return ' lens-flow__step--enter';
  };

  LensFlow.prototype.renderStep = function (index, title, hint, options, activeId, level) {
    var self = this;
    var step = element('div', 'lens-flow__step' + this.markSeen(level));
    step.setAttribute('data-lens-step', level);

    var head = element('div', 'lens-flow__step-head');

    head.appendChild(element('span', 'lens-flow__step-number', 'Step ' + index));
    head.appendChild(element('span', 'lens-flow__step-title', title));
    if (hint) head.appendChild(element('span', 'lens-flow__step-hint', hint));

    step.appendChild(head);

    var list = element('div', 'lens-flow__options');

    options.forEach(function (option) {
      var button = element('button', 'lens-flow__option');
      button.type = 'button';

      if (String(option.id) === String(activeId)) button.classList.add('is-active');

      if (option.image) {
        var media = element('span', 'lens-flow__option-media');
        var img = document.createElement('img');

        img.src = option.image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
        button.appendChild(media);
      }

      var head = element('span', 'lens-flow__option-head');
      head.appendChild(element('span', 'lens-flow__option-title', option.title));

      if (level !== 'variant' && option.price !== undefined && option.price !== null) {
        var priceText = option.price > 0 ? '+' + money(option.price) : 'Included';
        head.appendChild(element('span', 'lens-flow__option-price', priceText));
      }

      button.appendChild(head);

      if (option.description) {
        button.appendChild(element('span', 'lens-flow__option-desc', option.description));
      }

      button.addEventListener('click', function () {
        self.select(level, option);
      });

      list.appendChild(button);
    });

    step.appendChild(list);
    return step;
  };

  LensFlow.prototype.sunTwin = function () {
    if (this.twinData !== undefined) return this.twinData;

    var node = this.scope && this.scope.querySelector('[data-lens-sun-twin]');

    try {
      this.twinData = node ? JSON.parse(node.textContent) : null;
    } catch (error) {
      this.twinData = null;
    }

    return this.twinData;
  };

  LensFlow.prototype.sunHref = function (type) {
    var twin = this.sunTwin();
    if (!twin || !twin.rxValue) return '';

    var data = this.form ? new FormData(this.form) : null;
    var variant = twin.variants.filter(function (candidate) {
      return twin.options.every(function (name, index) {
        if (index === twin.lensIndex) return candidate.options[index] === twin.rxValue;
        return !data || candidate.options[index] === data.get('options[' + name + ']');
      });
    })[0];

    if (!variant) return '';

    var params = ['variant=' + variant.id, 'lens=rx'];
    if (type && type.name) params.push('rx_type=' + encodeURIComponent(type.name));

    return twin.url + '?' + params.join('&');
  };

  LensFlow.prototype.appendSunLink = function (step, type) {
    var self = this;
    var href = this.sunHref(type);
    var list = step.querySelector('.lens-flow__options');
    if (!href || !list) return;

    var link = element('a', 'lens-flow__option lens-flow__option--link');
    link.href = href;

    var twin = this.sunTwin();
    if (twin.rxImage) {
      var media = element('span', 'lens-flow__option-media');
      var img = document.createElement('img');

      img.src = twin.rxImage;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
      link.appendChild(media);
    }

    var head = element('span', 'lens-flow__option-head');
    head.appendChild(element('span', 'lens-flow__option-title', 'Sun'));
    head.appendChild(element('span', 'lens-flow__option-price', 'Shop SunStoggles →'));
    link.appendChild(head);
    link.appendChild(
      element(
        'span',
        'lens-flow__option-desc',
        'Tinted prescription lenses, polarized or not. Opens SunStoggles with this frame and color picked.'
      )
    );

    link.addEventListener('click', function () {
      var current = self.sunHref(type);
      if (current) link.href = current;
    });

    list.appendChild(link);
  };

  LensFlow.prototype.applyRequestedType = function () {
    if (this.requestedTypeApplied) return;
    this.requestedTypeApplied = true;

    var wanted = (window.location.search.match(/[?&]rx_type=([^&]+)/) || [])[1];
    if (!wanted || this.branch !== 'rx' || this.selection.type) return;

    wanted = decodeURIComponent(wanted);
    var type = this.typesForBranch().filter(function (candidate) {
      return candidate.name === wanted;
    })[0];

    if (type) this.selection = { type: type, item: null, variant: null };
  };

  LensFlow.prototype.renderStatus = function () {
    var self = this;

    if (this.opening) {
      var skeleton = element('div', 'lens-flow__skeleton');

      skeleton.setAttribute('role', 'status');
      skeleton.setAttribute('aria-label', 'Loading your prescription form');

      for (var i = 0; i < 4; i++) {
        skeleton.appendChild(element('span', 'lens-flow__skeleton-line'));
      }

      return skeleton;
    }

    var wrap = element('div', 'lens-flow__status lens-flow__status--error');
    wrap.appendChild(
      element(
        'p',
        'lens-flow__error',
        'We could not load the prescription form. Use the lens selector button below, or try again.'
      )
    );

    var retry = element('button', 'lens-flow__cta btn', 'Try again');
    retry.type = 'button';
    retry.addEventListener('click', function () {
      self.failed = false;
      self.openPanel();
    });

    wrap.appendChild(retry);
    return wrap;
  };

  LensFlow.prototype.render = function () {
    // The prescription form arrives well after the step was scrolled to, and it
    // is tall enough that any layout shift leaves the customer partway down it.
    // Re-anchor on arrival unless they have taken over the scroll themselves.
    var justMounted = this.panelMounted && !this.wasPanelMounted;
    this.wasPanelMounted = this.panelMounted;

    var mountedHost =
      this.panelMounted && this.host && this.host.parentElement === this.container ? this.host : null;

    if (mountedHost) this.container.removeChild(mountedHost);
    this.container.innerHTML = '';

    if (this.bootFailed || (this.branch !== 'rx' && this.branch !== 'readers')) {
      this.pendingScroll = null;
      this.container.hidden = true;
      this.container.style.paddingBottom = '';
      this.updateSticky();
      return;
    }

    this.container.hidden = false;

    if (this.soldOut) {
      this.pendingScroll = null;
      this.selection = { type: null, item: null, variant: null };
      this.seenSteps = {};

      var soldOut = element('div', 'lens-flow__status lens-flow__status--soldout');
      soldOut.appendChild(element('p', 'lens-flow__soldout-title', 'Sold out'));
      soldOut.appendChild(
        element(
          'p',
          'lens-flow__soldout-text',
          'Prescription lenses are sold out for this frame right now. Check back soon, or choose a non-prescription lens.'
        )
      );
      this.container.appendChild(soldOut);

      this.host = mountedHost || element('div', 'lens-flow__panel');
      this.container.appendChild(this.host);
      this.updateSticky();
      return;
    }

    if (!this.config) {
      var loading = element('div', 'lens-flow__skeleton');
      loading.setAttribute('role', 'status');
      loading.setAttribute('aria-label', 'Loading lens options');

      for (var line = 0; line < 4; line++) {
        loading.appendChild(element('span', 'lens-flow__skeleton-line'));
      }

      this.container.appendChild(loading);

      if (this.bootSlow) {
        this.container.appendChild(
          element('p', 'lens-flow__status', 'Still loading lens options — one moment…')
        );
      }

      this.host = mountedHost || element('div', 'lens-flow__panel');
      this.container.appendChild(this.host);
      this.updateSticky();
      return;
    }

    var types = this.typesForBranch();
    var readers = this.branch === 'readers';
    var step = 0;

    if (this.branch === 'rx') {
      step += 1;
      this.container.appendChild(
        this.renderStep(
          step,
          'Choose your prescription type',
          'Match this to what your eye doctor prescribed.',
          types,
          this.selection.type && this.selection.type.id,
          'type'
        )
      );
    }

    if (this.selection.type) {
      step += 1;
      var itemStep = this.renderStep(
        step,
        readers ? 'Choose your reader lens' : 'Choose your lens',
        'Lens price is added to the frame.',
        this.selection.type.items,
        this.selection.item && this.selection.item.id,
        'item'
      );
      if (!readers) this.appendSunLink(itemStep, this.selection.type);
      this.container.appendChild(itemStep);
    }

    if (this.selection.item && this.selection.item.variants.length > 1) {
      step += 1;
      this.container.appendChild(
        this.renderStep(
          step,
          'Choose your coating',
          '',
          this.selection.item.variants,
          this.selection.variant && this.selection.variant.id,
          'variant'
        )
      );
    }

    if (this.isComplete()) {
      step += 1;
      var head = element(
        'div',
        'lens-flow__step-head lens-flow__step-head--panel' +
          (this.markSeen('panel') ? ' lens-flow__step-head--enter' : '')
      );
      head.setAttribute('data-lens-step', 'panel');
      head.appendChild(element('span', 'lens-flow__step-number', 'Step ' + step));
      head.appendChild(
        element(
          'span',
          'lens-flow__step-title',
          readers ? 'Enter your reading strength' : 'Enter your prescription'
        )
      );
      head.appendChild(
        element(
          'span',
          'lens-flow__step-hint',
          readers
            ? 'Pick the strength you read with.'
            : 'You will need your prescription details and a photo or PDF of it.'
        )
      );
      this.container.appendChild(head);

      var reuse = this.renderReuse();
      if (reuse) this.container.appendChild(reuse);
    } else {
      // Preview the steps still ahead.
      var ghost = step;

      if (!this.selection.type) {
        ghost += 1;
        this.container.appendChild(
          ghostHead(ghost, readers ? 'Choose your reader lens' : 'Choose your lens')
        );
      }

      /*
        A lens with a single coating skips the coating step, so before one is
        picked the step is only a possibility. It is previewed whenever any lens
        still in play has more than one coating — every Readers lens does, and so
        does every clear lens, so the common path matches. The alternative was
        leaving it out, which made the step appear from nowhere on arrival.
      */
      if (!this.selection.item) {
        var reachable = this.selection.type
          ? this.selection.type.items || []
          : types.reduce(function (all, type) {
              return all.concat(type.items || []);
            }, []);

        var mayCoat = reachable.some(function (item) {
          return item.variants && item.variants.length > 1;
        });

        if (mayCoat) {
          ghost += 1;
          this.container.appendChild(ghostHead(ghost, 'Choose your coating'));
        }
      }

      ghost += 1;
      this.container.appendChild(
        ghostHead(ghost, readers ? 'Enter your reading strength' : 'Enter your prescription')
      );
    }

    if (!this.panelMounted && (this.opening || this.failed)) {
      this.container.appendChild(this.renderStatus());
    }

    this.host = mountedHost || element('div', 'lens-flow__panel');
    this.container.appendChild(this.host);

    // Synced last: the panel's fields are only queryable once the host is back
    // in the document, and the bar mirrors them.
    this.updateSticky();
    this.updateTail();

    if (justMounted && !this.userScrolled) {
      this.pendingScroll = { key: 'panel', gentle: false };
    }

    this.flushScroll();
  };

  function boot() {
    var container = document.querySelector('[data-lens-flow]');
    if (!container) return;

    var enclosingForm = container.closest('form');
    if (enclosingForm && enclosingForm.parentNode) {
      enclosingForm.parentNode.insertBefore(container, enclosingForm.nextSibling);
    }

    var flow = new LensFlow(container);
    var scope = flow.scope;
    if (!scope) return;

    flow.start();
    flow.soldOut = scope.getAttribute('data-lens-sold-out') === 'true';
    flow.setBranch(scope.getAttribute('data-lens-branch') || '');
    flow.ready = true;

    ['wheel', 'touchmove', 'keydown'].forEach(function (type) {
      window.addEventListener(
        type,
        function () {
          flow.userScrolled = true;
        },
        { passive: true }
      );
    });

    // Every prescription field lives under the container, so one delegated pair
    // keeps the cart button's enabled state in step with the form.
    ['input', 'change'].forEach(function (type) {
      container.addEventListener(type, function (event) {
        var target = event.target;
        if (target && target.closest && target.closest('#la-prescription-form')) {
          flow.formTouched = true;
        }
        flow.updateSticky();
      });
    });

    // Lens Advizor finishes building the prescription fields after the panel is
    // handed over, so the bar re-syncs whenever the panel's contents change.
    // Nothing here writes into the container, so this cannot feed itself.
    window.addEventListener('resize', function () {
      flow.updateTail();
    });

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        flow.updateSticky();
        flow.updateTail();
      });
    }).observe(container, { childList: true, subtree: true });

    if (flow.form) {
      flow.form.addEventListener('change', function () {
        flow.updateSticky();
      });
    }

    document.addEventListener('LensAdvizor:addToCart:success', function () {
      flow.addedToCart = true;
    });

    window.LensFlowBridge.onClose(function () {
      flow.panelMounted = false;

      if (flow.addedToCart) {
        flow.addedToCart = false;
        flow.resetAfterAdd();
        return;
      }

      flow.render();
    });

    new MutationObserver(function () {
      flow.setSoldOut(scope.getAttribute('data-lens-sold-out') === 'true');
      flow.setBranch(scope.getAttribute('data-lens-branch') || '');
    }).observe(scope, {
      attributes: true,
      attributeFilter: ['data-lens-branch', 'data-lens-sold-out']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
